import ExpandableView from './_expandable-view.js'
import Image from './_image.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'

export default {
  name: 'AggregatedMarketPane',
  values: {
    showMatchAccaIcon: true,
    showCashoutIcon: true,
    loadingDebounceDelay: 1000,
    expandable: {
      configSet: ExpandableView,
      configValues: {
        headerContainer: {
          style: {
            base: {
              minHeight: '40px',
            },
          },
        },
      },
    },
    cashoutIcon: {
      configSet: Image,
      configValues: {
        src: 'cashout',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    matchAccaIcon: {
      configSet: Image,
      configValues: {
        src: 'system-betbuilder',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          popup: {
            container: {
              style: {
                width: '296px',
                top: '38px',
                right: 0,
                left: undefined,
              },
            },
            arrowheadOffset: '-8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
